import { addClass, css, hasClass, removeClass } from "../utils/CssUtils";
import { addEventListener } from '../utils/EventUtils';
import { catchPromiseException, getPageHeight, getPageWidth } from "../utils/JsUtils";
import AbstractComponent from "./AbstractComponent";
import anime from "animejs";
import Logger from '../utils/Logger';


export default class MediaFullscreen extends AbstractComponent {
    constructor(...args) {
        Logger.log('MediaFullscreen->constructor()');
        super(...args);

        this.classname = 'c-media-fullscreen';
        this.initDomElements();
        this.addEventListeners();
    }

    initDomElements() {
        this.$scrollDownButton = this.$el.querySelector(this.getSelector('__scroll-down-button'));
        this.$media = this.$el.querySelector('.c-media');
        this.$muteButton = this.$el.querySelector(this.getSelector('__mute-button'));
        this.$fullscreenButton = this.$el.querySelector(this.getSelector('__fullscreen-button'));
        this.isSquareOnMobile = hasClass(this.$el, this.getClassname('--is-square-on-mobile'));
        this.hasDock = hasClass(this.$el, this.getClassname('--has-dock'));
        this.$dock = this.app.$body.querySelector('.c-dock');
    }

    addEventListeners() {
        if (this.$media) {
            this.boundResizeListener = this.app.on('resize', this.updateHeight.bind(this));
        }
        if (this.$scrollDownButton) {
            addEventListener(this.$scrollDownButton, 'click', this.scrollDownButtonListener.bind(this));
        }
        if (this.$muteButton && this.$media) {
            addEventListener(this.$muteButton, 'click', this.muteButtonListener.bind(this));
            addEventListener(this.$media, 'volumechange', this.volumeChangeMediaListener.bind(this));
        }
        if (this.$fullscreenButton && this.$media) {
            addEventListener(this.$fullscreenButton, 'click', this.fullscreenButtonListener.bind(this));
            addEventListener(this.$media, 'fullscreenchange', this.fullscreenChangeListener.bind(this));
            addEventListener(this.$media, 'webkitendfullscreen', this.webkitEndFullscreenMediaListener.bind(this));
        }
        if (this.hasDock) {
            this.app.addListener('dock-height-update', this.dockHeightUpdate.bind(this));
        }
        this.updateHeight();
    }

    scrollDownButtonListener() {
        this.$scrollDownButton.blur();
        const offset = this.$el.getBoundingClientRect().height;
        const duration = 1000 + (2 * offset / 10);
        anime({
            targets: [document.documentElement, document.body],
            scrollTop: offset,
            duration: duration,
            easing: 'easeInOutQuint'
        });
    }

    muteButtonListener() {
        this.$muteButton.blur();
        this.$media.muted = !this.$media.muted;
    }

    volumeChangeMediaListener() {
        const muteOnClass = this.getClassname('__mute-button--mute-on');
        const muteOffClass = this.getClassname('__mute-button--mute-off');
        const muted = this.$media.muted;
        if (muted) {
            removeClass(this.$muteButton, muteOffClass);
            addClass(this.$muteButton, muteOnClass);
        } else {
            removeClass(this.$muteButton, muteOnClass);
            addClass(this.$muteButton, muteOffClass);
        }
    }

    fullscreenButtonListener() {
        this.$fullscreenButton.blur();
        const requestFullscreen = this.$media.requestFullscreen
            || this.$media.webkitRequestFullscreen
            || this.$media.webkitEnterFullScreen
            || this.$media.mozRequestFullScreen
            || this.$media.msRequestFullscreen;
        if (requestFullscreen) {
            if (this.isFirefox()) {
                this.$media.setAttribute('controls', '');
            }
            requestFullscreen.call(this.$media);
            this.$media.muted = false;
        }
    }

    isFirefox() {
        return (navigator.userAgent.toLowerCase().indexOf('firefox') > -1);
    }

    fullscreenChangeListener() {
        if (this.isFirefox() && !document.fullscreenElement) {
            this.$media.removeAttribute('controls');
        }
    }

    webkitEndFullscreenMediaListener() {
        setInterval(() => catchPromiseException(this.$media.play()), 300);
    }

    updateHeight() {
        const pageHeight = getPageHeight();
        const pageWidth = getPageWidth();
        let mediaFullscreenHeight = pageHeight;

        if (this.app.isBreakpointUp('md')) {
            if (this.hasDock && this.$dock) {
                const dockHeight = this.$dock.getBoundingClientRect().height;
                mediaFullscreenHeight = pageHeight - dockHeight;
                css(this.$el, { 'height': mediaFullscreenHeight + 'px' });
            } else {
                css(this.$el, { 'height': null });
            }
        } else {
            if (this.isSquareOnMobile) {
                css(this.$el, { 'height': pageWidth + 'px' });
            } else {
                css(this.$el, { 'height': null });
            }
        }
    }

    dockHeightUpdate() {
        this.updateHeight();
        const breakpoint = this.app.getCurrentBreakpoint();
        this.app.emit('breakpoint-update', breakpoint, breakpoint);
    }

    destroy() { }
}
